import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { u as n } from "./index-6a632112.mjs";
import { s as t, h as b, c as H, Q as d, f as u, a as y, e as S } from "./themes-5f0b3c3d.mjs";
import { l as s } from "./lineHeights-72d3110c.mjs";
import { t as o } from "./textStyles-42cab346.mjs";
import { a as L, b as A } from "./superScript-393c70dc.mjs";
import x from "react";
import { Divider as k } from "./divider.js";
import { useWindowDimensions as U } from "./useWindowDimensions.js";
import { h as w } from "./hTag-40b23797.mjs";
import "./fontWeights-a25f8f91.mjs";
const j = n.div`
  display: flex;
  flex-direction: column;
  gap: ${t["4x"]};
`, D = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, E = n(w)`
  font-family: ${(e) => e.theme.components.pageHeader.primaryFont};
  font-weight: ${b.XL.fontWeight};
  color: ${(e) => e.theme.components.pageHeader.titleColor};

  ${({ $titleSize: e }) => {
  switch (e) {
    case "large":
      return `
          font-size: ${o.headline.l.fontSize};
          line-height: ${s.xlarge};
        `;
    case "extraLarge":
      return `
          font-size: ${o.headline.xl.fontSize};
          line-height: ${s.xxlarge};
        `;
    case "medium":
    default:
      return `
          font-size: ${o.headline.m.fontSize};
          line-height: ${o.headline.l.lineHeight};
        `;
  }
}}
`, C = n.div`
  ${L()}
  ${A()}
  display: flex;
  flex-direction: column;
  row-gap: ${t["4x"]};
  justify-content: space-around;
  padding: ${t["6x"]} 0px 0px 0px;

  background: ${({ $hideBackground: e }) => e ? "transparent" : `${H.brandTwilight[0]}`};

  @media ${d.laptopAndUp} {
    padding: ${t["6x"]} 0px 0px 0px;
  }

  @media ${d.desktopAndUp} {
    padding: ${t["6x"]} 0px 0px 0px;
  }
  @media ${d.wideScreenAndUp} {
    padding: ${t["6x"]} 0px 0px 0px;
  }
`, F = n.div`
  display: flex;
  justify-content: space-between;
`, $ = n.div`
  display: flex;
  gap: ${t["4x"]};
  flex-direction: column;

  button {
    width: 100%;
  }

  @media ${d.tabletAndUp} {
    flex-direction: row;
    gap: ${t["6x"]};
  }
`, Q = n(w)`
  align-self: stretch;
  color: ${(e) => e.theme.components.pageHeader.subTitleColor};
  font-family: ${u.inter};
  font-size: ${y.medium};
  font-style: normal;
  font-weight: ${S.medium.L.fontWeight};
  line-height: ${s.large};
`, R = n.p`
  ${D()}
  align-self: stretch;
  color: ${(e) => e.theme.components.pageHeader.descriptionColor};
  font-family: ${u.inter};
  font-size: ${y.small};
  font-style: normal;
  font-weight: ${S.regular.L.fontWeight};
  line-height: ${s.medium};
`, V = n.div`
  display: flex;
  flex-direction: column;
  gap: ${t["1x"]};
`;
function Y({
  title: e = "Pageheader title",
  children: c,
  actionButtons: a,
  titleProp: p = { size: "medium", title: e, headingLevel: "h1" },
  subTitleProp: m,
  description: f,
  hideBackground: v = !1,
  bottomStroke: z = !0,
  breadCrumbContent: h,
  tabContent: g,
  ...T
}) {
  let r = !1;
  const { width: W } = U();
  return W < 1024 ? r = !0 : r = !1, /* @__PURE__ */ l(C, { $hideBackground: v, ...T, children: [
    h && /* @__PURE__ */ i("div", { children: h }),
    /* @__PURE__ */ l(j, { children: [
      /* @__PURE__ */ l(V, { children: [
        /* @__PURE__ */ l(F, { children: [
          /* @__PURE__ */ i(
            E,
            {
              $titleSize: p.size,
              as: p.headingLevel,
              children: p.title
            }
          ),
          !r && x.isValidElement(a) && /* @__PURE__ */ i($, { children: a })
        ] }),
        m && /* @__PURE__ */ i(Q, { as: m.headingLevel, children: m.subTitle })
      ] }),
      f && /* @__PURE__ */ i(R, { children: f }),
      r && x.isValidElement(a) && /* @__PURE__ */ i($, { children: a })
    ] }),
    g && /* @__PURE__ */ i("div", { children: g }),
    c && /* @__PURE__ */ i("div", { children: c }),
    z && /* @__PURE__ */ i(k, {})
  ] });
}
export {
  Y as PageHeader
};
